import { useTranslation } from 'react-i18next'

import { getManagerProfileOptions } from '../../../../../../../api'
import { getItemsFromIdwellApiResponse } from '../../../../../../../utils/api'
import { FieldStackedLabel } from '../../../../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../../Formik'
import { toUserSelectItemsFromOption, UserSelect } from '../../../../../../User'
import { LISTING_PROFILE_INFO_ITEM_TITLE_KEY } from '../../RentalPortalListingProfileHeaderInfoItems.constants'
import {
  LISTING_RESPONSIBLE_MANAGER_FIELD_NAME,
  QA_NAME_LISTING_RESPONSIBLE_MANAGER_SELECT,
} from '../ListingResponsibleManagerModal.constants'

function ListingResponsibleManagerModalFields() {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikField
        Component={FormFieldSelectNG}
        Field={FieldStackedLabel}
        Select={UserSelect}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t(
                'RentalPortal.ListingProfileResponsibleManagerPlaceholderKey'
              ),
            },
          },
        }}
        emptyValue={null}
        fieldComponentProps={{
          label: t(LISTING_PROFILE_INFO_ITEM_TITLE_KEY.responsibleManager),
        }}
        getData={getManagerProfileOptions}
        getDataItems={getItemsFromIdwellApiResponse}
        getErrorProps={getFormikFormFieldErrorProps}
        listProps={{
          emptyProps: {
            text: t(
              'RentalPortal.ListingProfileResponsibleManagerNoOptionsKey'
            ),
          },
        }}
        name={LISTING_RESPONSIBLE_MANAGER_FIELD_NAME}
        qaName={QA_NAME_LISTING_RESPONSIBLE_MANAGER_SELECT}
        toPreparedItems={toUserSelectItemsFromOption}
      />
    </FormFieldsContainer>
  )
}

export default ListingResponsibleManagerModalFields
